import { gql } from '@apollo/client';
import { apolloClient } from '~/apollo-client';

export const FETCH_COUNTIES_BY_ZIP = gql`
  query Flex_CountiesByZip($zipCode: String!) {
    countiesByZip(zipCode: $zipCode) {
      id
      name
    }
  }
`;

export interface SalesforceCountyOption {
  id: number;
  name: string;
}

interface CountiesByZipQuery {
  countiesByZip: SalesforceCountyOption[];
}

interface CountiesByZipVariables {
  zipCode: string;
}

export const fetchCountiesByZip = async (zipCode: string): Promise<SalesforceCountyOption[]> => {
  const { data } = await apolloClient.query<CountiesByZipQuery, CountiesByZipVariables>({
    query: FETCH_COUNTIES_BY_ZIP,
    variables: { zipCode },
    fetchPolicy: 'no-cache',
  });
  return data?.countiesByZip ?? [];
};
